export function guessStorageAddress() {
  const host = window.location.host
  if (host.toLowerCase().indexOf('localhost') > -1) {
    return 'http://localhost:4050'
  } else {
    return 'https://' + host.replace(/^[a-zA-Z0-9-]+\./, 'storage.')
  }
}
